import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { getQuickformState } from "@/helpers/quickformHelpers";
import { useQuickFormStore } from "@/store/quickFormStore";
import { computed } from "vue";
import QuickformBaseForm from "./QuickformBaseForm.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RoundTrip',
  setup(__props) {

const quickFormStore = useQuickFormStore();

const departures = computed(() => quickFormStore.getDepartures);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QuickformBaseForm, {
    hasReturn: "",
    booking: _unref(getQuickformState)(departures.value)
  }, null, 8, ["booking"]))
}
}

})